import { render, staticRenderFns } from "./home.vue?vue&type=template&id=5d56a88b&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=5d56a88b&prod&lang=scss&scoped=true"
import style1 from "./home.vue?vue&type=style&index=1&id=5d56a88b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56a88b",
  null
  
)

export default component.exports